import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Select from "react-select";
import DynamicAlert from "../../helpers/dynamicAlert";
import {locationService} from "../../service/location/location.service";

export const UpdateAddressModal = (updateAddressDetails) => {
    const {
        addressUpdateShow,
        addressUpdateHandleClose,
        addressHandleChange,
        updateAddress,
        addressDetails,
        customerId,
        alert,
        processing
    } = updateAddressDetails;

    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);

    useEffect(() => {
        if (addressUpdateShow) {
            locationService.getStates().then(data => {
                if (data) {
                    const stateOptions = data.map(s => ({
                        value: s?.stateId,
                        label: s?.stateName
                    }));
                    setStates(stateOptions);

                    // Set default state selection from addressDetails
                    if (addressDetails?.state) {
                        const defaultState = stateOptions.find(s => s.value === addressDetails.state);
                        setSelectedState(defaultState || null);
                    }
                }
            })
        }
    }, [addressUpdateShow, addressDetails]);


    const handleStateChange = (option) => {
        setSelectedState(option);
        addressHandleChange({
            target: {id: "state", name: "state", value: option?.value || ""}
        });
    };


    const selectStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '38px',
            height: '38px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '38px',
            padding: '0 6px'
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '38px'
        })
    };

    return (
        <Modal show={addressUpdateShow} onHide={addressUpdateHandleClose} centered>
            <DynamicAlert alert={alert}/>
            <Modal.Header closeButton>
                <Modal.Title>Update Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <div className="row g-3">
                        <div className="col-md-6 d-flex flex-column">
                            <Form.Label className="fw-bold">First Name*</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={addressHandleChange}
                                id="firstName"
                                name="firstName"
                                placeholder="First name"
                                defaultValue={addressDetails?.firstName}
                            />
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <Form.Label className="fw-bold">Last Name*</Form.Label>
                            <Form.Control
                                id="lastName"
                                name="lastName"
                                type="text"
                                onChange={addressHandleChange}
                                placeholder="Last Name"
                                defaultValue={addressDetails?.lastName}
                            />
                        </div>

                        <div className="col-12 d-flex flex-column">
                            <Form.Label className="fw-bold">Address Line 1*</Form.Label>
                            <Form.Control
                                id="address1"
                                name="address1"
                                type="text"
                                onChange={addressHandleChange}
                                placeholder="Enter address line 1"
                                defaultValue={addressDetails?.address1}
                            />
                        </div>
                        <div className="col-12 d-flex flex-column">
                            <Form.Label className="fw-bold">Address Line 2</Form.Label>
                            <Form.Control
                                id="address2"
                                name="address2"
                                type="text"
                                onChange={addressHandleChange}
                                placeholder="Enter address line 2"
                                defaultValue={addressDetails?.address2}
                            />
                        </div>

                        <div className="col-12 d-flex flex-column">
                            <Form.Label className="fw-bold">State*</Form.Label>
                            <Select
                                options={states}
                                value={selectedState}
                                onChange={handleStateChange}
                                placeholder="Select state"
                                isClearable
                                isSearchable
                                styles={selectStyles}
                            />
                        </div>

                        <div className="col-12 d-flex flex-column">
                            <Form.Label className="fw-bold">City*</Form.Label>
                            <Form.Control
                                type="text"
                                onChange={addressHandleChange}
                                id="city"
                                name="city"
                                placeholder="City"
                                defaultValue={addressDetails?.city}
                            />
                        </div>
                        <div className="col-md-6 d-flex flex-column">
                            <Form.Label className="fw-bold">Zip Code*</Form.Label>
                            <Form.Control
                                onChange={addressHandleChange}
                                id="zipCode"
                                name="zipCode"
                                type="number"
                                placeholder="Zip Code"
                                defaultValue={addressDetails?.zipCode}
                            />
                        </div>

                        <div className="col-md-6 d-flex flex-column">
                            <Form.Label className="fw-bold">Phone*</Form.Label>
                            <Form.Control
                                onChange={addressHandleChange}
                                id="phoneNo"
                                name="phoneNo"
                                type="number"
                                placeholder="Phone Number"
                                defaultValue={addressDetails?.phoneNo}
                            />
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={addressUpdateHandleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={updateAddress(customerId)} disabled={processing}>
                    {processing ? 'Saving' : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
